export default 'https://tme.understood.org/assets/collectible.2544f17c.glb'